<template>
  <v-col
    v-orphans
    cols="12"
    class="pa-0 faq-list mb-10"
  >
    <h2 class="sz-primary-grey--text f-24 font-weight-medium text-center mb-5">
      {{ $t('label.faq') }}
    </h2>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel
        v-for="(item, index) in faq"
        :key="index"
        class="sz-primary-grey--text elevation-2"
      >
        <v-expansion-panel-title
          :id="getQuestionId(index)"
          class="font-weight-medium f-18"
          @click="goToQuestion(index)"
        >
          {{ item.header }}
        </v-expansion-panel-title>
        <v-expansion-panel-text class="f-16">
          <div
            class="line-height-2"
            v-html="item.content"
          />
          <div
            v-if="item?.button"
            class="my-3 mx-2 d-flex justify-center"
          >
            <BaseButton :href="item.button?.href">
              {{ item.button?.text }}
            </BaseButton>
          </div>
          <div
            v-if="item?.link"
            class="mt-3"
          >
            <a
              target="_blank"
              class="primary-link"
              :href="item.link.href"
            >{{ item.link.text }}</a>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <slot>
      <v-row
        no-gutters
        justify="center"
        class="mt-10"
      >
        <v-col cols="auto">
          <BaseButton
            :href="LINKS.guide"
            variant="secondary"
          >
            {{ $t('label.showGuide') }}
          </BaseButton>
        </v-col>
      </v-row>
    </slot>
  </v-col>
</template>

<script setup lang="ts">
import BaseButton from '@/components/widgets/BaseButton.vue';
import { LINKS } from '@/constants/externalLinks';
import { ref } from 'vue';
import type { Maybe } from '@/types';
import { useGoTo } from 'vuetify';
import type { FaqItem } from '@/types/faq.ts';

type Props = {
    faq?: FaqItem[];
};

const goTo = useGoTo();

withDefaults(defineProps<Props>(), {
    faq: () => []
});

const panel = ref<Maybe<number>>(null);

const getQuestionId = (index: number): string => 'faq-question-' + index;

const goToQuestion = function (index: number) {
    setTimeout(() => goTo('#' + getQuestionId(index)), 250);
};

</script>
